import { SpEntityType } from '@/config/common';
import type { ISystem, ISystemGroup } from '../types';

export function isGroup(g_OR_s: ISystemGroup | ISystem): g_OR_s is ISystemGroup {
  return (g_OR_s as ISystemGroup)?.vertexType === SpEntityType.Group;
}
